import { Avatar } from '#/components/Avatar/Avatar';
import { ButtonOrLink } from '#/components/ButtonOrLink/ButtonOrLink';
import { Divider } from '#/components/Divider/Divider';
import { Text } from '#/components/Text/Text';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { ApiEvent } from '#/modules/listing/events/api/types/ApiEvent';
import { viewUserProfilePath } from '#/modules/userProfile/routing/userProfile.paths';
import { colors } from '#/theme/theme';

import { ListingViewSidebarLink } from './ListingViewSidebar.styled';
import { ListingViewSidebarEventHost_Hide_1 } from './ListingViewSidebarEventHost.styled';

type Props = {
  creator: NonNullable<ApiEvent['creator']>;
};

export function ListingViewSidebarEventHost({ creator }: Props) {
  const { i18n } = useI18n();

  return (
    <ListingViewSidebarEventHost_Hide_1>
      <div
        style={{
          display: 'flex',
          gap: 16,
          flexDirection: 'column',
          alignItems: 'start',
        }}
      >
        <Text style={{ color: colors.lightContentGrey }}>
          {i18n('Hosted By')}
        </Text>

        <ButtonOrLink
          type="link"
          href={viewUserProfilePath.with({
            username: creator.username,
          })}
        >
          <Avatar
            border="white"
            image={creator.image}
            name={creator.name}
            size="xs"
          />
        </ButtonOrLink>

        <ListingViewSidebarLink
          to={viewUserProfilePath.with({
            username: creator.username,
          })}
        >
          {creator.name}
        </ListingViewSidebarLink>
      </div>
      <Divider marginTop={24} marginBottom={24} />
    </ListingViewSidebarEventHost_Hide_1>
  );
}
